import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationStageFinanceAttributions(companyId, regulationId, stageId) {
	return dataTransferWrap(
		ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION].getRegulationStageFinanceAttributions,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
			},
		}
	)
}

function createRegulationStageFinanceAttribution(companyId, regulationId, stageId, data) {
	return dataTransferWrap(
		ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION]
			.createRegulationStageFinanceAttribution,
		{
			urlParams: {
				companyId,
				regulationId,
				stageId,
			},
			...data,
		}
	)
}

function getRegulationStageFinanceAttribution(
	companyId,
	regulationId,
	stageId,
	financeAttributionId
) {
	return dataTransferWrap(
		ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION].getRegulationStageFinanceAttribution,
		{
			urlParams: {
				companyId,
				regulationId,
				stageId,
				financeAttributionId,
			},
		}
	)
}

function patchRegulationStageFinanceAttribution(
	companyId,
	regulationId,
	stageId,
	financeAttributionId,
	data
) {
	return dataTransferWrap(
		ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION]
			.patchRegulationStageFinanceAttribution,
		{
			urlParams: {
				companyId,
				regulationId,
				stageId,
				financeAttributionId,
			},
			...data,
		}
	)
}

function putRegulationStageFinanceAttribution(
	companyId,
	regulationId,
	stageId,
	financeAttributionId,
	data
) {
	return dataTransferWrap(
		ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION].putRegulationStageFinanceAttribution,
		{
			urlParams: {
				companyId,
				regulationId,
				stageId,
				financeAttributionId,
			},
			...data,
		}
	)
}

function deleteRegulationStageFinanceAttribution(
	companyId,
	regulationId,
	stageId,
	financeAttributionId
) {
	return dataTransferWrap(
		ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION].deleteRegulationStageFinanceAttribution,
		{
			urlParams: {
				companyId,
				regulationId,
				stageId,
				financeAttributionId,
			},
		}
	)
}

export default {
	getRegulationStageFinanceAttributions,
	getRegulationStageFinanceAttribution,
	patchRegulationStageFinanceAttribution,
	putRegulationStageFinanceAttribution,
	createRegulationStageFinanceAttribution,
	deleteRegulationStageFinanceAttribution,
}
